/* PRAHLA SILKS — theme.js */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => {
    const f = (window.PRAHLA && window.PRAHLA.moneyFormat) || '₹{{amount}}';
    const n = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return f.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, n).replace(/<[^>]*>/g, '');
  };

  /* ---------- toast ---------- */
  let toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    requestAnimationFrame(() => toastEl.classList.add('is-on'));
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }
  window.prahlaToast = toast;

  /* ---------- drawers ---------- */
  const scrim = $('#scrim');
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    $$('.drawer.is-on').forEach(x => x.classList.remove('is-on'));
    d.classList.add('is-on'); d.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('is-on');
    document.body.classList.add('is-locked');
    const f = d.querySelector('input,button,a'); f && setTimeout(() => f.focus(), 320);
  }
  function closeDrawers() {
    $$('.drawer.is-on').forEach(d => { d.classList.remove('is-on'); d.setAttribute('aria-hidden', 'true'); });
    scrim && scrim.classList.remove('is-on');
    document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus();
  }
  window.prahlaOpen = openDrawer; window.prahlaClose = closeDrawers;
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  scrim && scrim.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- scroll reveal ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function observeReveals(root) {
    $$('[data-rv]', root || document).forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  }
  observeReveals();
  window.prahlaReveal = observeReveals;

  /* ---------- header hide on scroll ---------- */
  const hdr = $('.hdr');
  if (hdr) {
    let prev = 0;
    addEventListener('scroll', () => {
      const y = scrollY;
      hdr.classList.toggle('is-stuck', y > 8);
      if (y > 300 && y > prev + 4) hdr.classList.add('is-hidden');
      else if (y < prev - 4) hdr.classList.remove('is-hidden');
      prev = y;
    }, { passive: true });
  }

  /* ---------- announcement rotator ---------- */
  const ann = $$('.announce__slide');
  if (ann.length > 1) {
    let i = 0;
    setInterval(() => { ann[i].classList.remove('is-on'); i = (i + 1) % ann.length; ann[i].classList.add('is-on'); }, 4200);
  }

  /* ---------- hero slideshow ---------- */
  $$('[data-hero]').forEach(hero => {
    const slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero);
    if (!slides.length) return;
    let idx = 0, timer;
    const dur = parseInt(hero.dataset.hero, 10) || 6000;
    const go = n => {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === idx));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === idx));
    };
    const play = () => { if (dur > 0 && slides.length > 1) timer = setInterval(() => go(idx + 1), dur); };
    const stop = () => clearInterval(timer);
    $('.hero__nav--next', hero)?.addEventListener('click', () => { stop(); go(idx + 1); play(); });
    $('.hero__nav--prev', hero)?.addEventListener('click', () => { stop(); go(idx - 1); play(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { stop(); go(k); play(); }));
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
    let sx = 0;
    hero.addEventListener('touchstart', e => { sx = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 45) go(dx < 0 ? idx + 1 : idx - 1);
      play();
    }, { passive: true });
    go(0); play();
  });

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach(box => {
    const btns = $$('.tab', box);
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => { x.classList.remove('is-on'); x.setAttribute('aria-selected', 'false'); });
      b.classList.add('is-on'); b.setAttribute('aria-selected', 'true');
      $$('.tabpanel', box).forEach(p => { p.hidden = p.id !== b.getAttribute('aria-controls'); });
    }));
  });

  /* ---------- rail arrows ---------- */
  $$('[data-rail-btn]').forEach(btn => btn.addEventListener('click', () => {
    const rail = document.getElementById(btn.getAttribute('data-rail-target'));
    if (!rail) return;
    rail.scrollBy({ left: (btn.dataset.railBtn === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: 'smooth' });
  }));

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(gal => {
    const thumbs = $$('.gal__thumb', gal), imgs = $$('.gal__stage > img', gal);
    let i = 0;
    const go = n => {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach((m, k) => m.classList.toggle('is-on', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      thumbs[i] && thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    thumbs.forEach((t, k) => {
      t.addEventListener('click', () => go(k));
      t.addEventListener('mouseenter', () => go(k));
    });
    $('.gal__arw--n', gal)?.addEventListener('click', () => go(i + 1));
    $('.gal__arw--p', gal)?.addEventListener('click', () => go(i - 1));
    let sx = 0;
    const stage = $('.gal__stage', gal);
    stage?.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    gal.addEventListener('prahla:image', e => {
      const target = imgs.findIndex(m => m.dataset.mediaId === String(e.detail));
      if (target > -1) go(target);
    });
    // desktop zoom on stage
    stage?.addEventListener('mousemove', e => {
      if (matchMedia('(hover:none)').matches) return;
      const r = stage.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
      imgs[i].style.transformOrigin = x + '% ' + y + '%';
      imgs[i].style.transform = 'scale(1.7)';
      imgs[i].style.transition = 'transform .15s linear';
    });
    stage?.addEventListener('mouseleave', () => {
      imgs.forEach(m => { m.style.transform = ''; m.style.transition = ''; });
    });
  });

  /* ---------- quantity ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    const input = $('input', b.closest('.qty'));
    const v = Math.max(1, (parseInt(input.value, 10) || 1) + (b.dataset.qty === 'up' ? 1 : -1));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variants ---------- */
  $$('[data-variant-form]').forEach(form => {
    const data = JSON.parse($('[data-variant-json]', form).textContent);
    const idField = $('[name="id"]', form);
    const priceEl = $('[data-v-price]', form), cmpEl = $('[data-v-compare]', form),
      saveEl = $('[data-v-save]', form), btn = $('[data-atc]', form), stockEl = $('[data-v-stock]', form);
    function current() {
      const chosen = $$('[data-opt].is-on', form).map(b => b.dataset.value);
      return data.find(v => v.options.every((o, k) => !chosen[k] || o === chosen[k])) || data[0];
    }
    function paint() {
      const v = current(); if (!v) return;
      idField.value = v.id;
      priceEl && (priceEl.textContent = money(v.price));
      if (cmpEl) {
        const on = v.compare_at_price && v.compare_at_price > v.price;
        cmpEl.style.display = on ? '' : 'none';
        cmpEl.textContent = on ? money(v.compare_at_price) : '';
        if (saveEl) {
          saveEl.style.display = on ? '' : 'none';
          saveEl.textContent = on ? Math.round((1 - v.price / v.compare_at_price) * 100) + '% OFF' : '';
        }
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.labelOn : btn.dataset.labelOff; }
      stockEl && (stockEl.textContent = v.available ? stockEl.dataset.on : stockEl.dataset.off);
      if (v.featured_media_id) $('[data-gallery]')?.dispatchEvent(new CustomEvent('prahla:image', { detail: v.featured_media_id }));
      const url = new URL(location); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('prahla:variant', { detail: v }));
    }
    $$('[data-opt]', form).forEach(b => b.addEventListener('click', () => {
      $$('[data-opt="' + b.dataset.opt + '"]', form).forEach(x => x.classList.remove('is-on'));
      b.classList.add('is-on');
      const lbl = $('[data-opt-label="' + b.dataset.opt + '"]', form);
      lbl && (lbl.textContent = b.dataset.value);
      paint();
    }));
    paint();
  });

  /* ---------- cart ---------- */
  async function refreshCart() {
    try {
      const r = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer');
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-contents]');
      const live = $('[data-cart-contents]');
      if (fresh && live) live.innerHTML = fresh.innerHTML;
      const c = await (await fetch('/cart.js')).json();
      $$('[data-cart-count]').forEach(el => {
        el.textContent = c.item_count;
        el.style.display = c.item_count ? '' : 'none';
      });
    } catch (err) { console.warn(err); }
  }
  window.prahlaRefreshCart = refreshCart;

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-atc-form]'); if (!form) return;
    e.preventDefault();
    const btn = $('[data-atc]', form); const label = btn && btn.textContent;
    btn && (btn.disabled = true, btn.textContent = window.PRAHLA?.strings?.adding || 'Adding…');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      const json = await res.json();
      if (json.status) throw new Error(json.description || json.message);
      await refreshCart(); openDrawer('cart-drawer');
    } catch (err) { toast(err.message || 'Could not add to cart'); }
    finally { btn && (btn.disabled = false, btn.textContent = label); }
  });

  document.addEventListener('click', async e => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +rm.dataset.cartRemove, quantity: 0 })
      });
      refreshCart(); toast(window.PRAHLA?.strings?.removed || 'Removed from cart');
    }
  });

  document.addEventListener('change', async e => {
    const q = e.target.closest('[data-cart-qty]'); if (!q) return;
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: +q.dataset.cartQty, quantity: Math.max(0, +q.value) })
    });
    refreshCart();
  });

  /* ---------- sticky add to cart ---------- */
  const sticky = $('[data-sticky-atc]'), anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    const setPad = on => document.documentElement.style.setProperty('--sticky-h', on ? sticky.offsetHeight + 'px' : '0px');
    new IntersectionObserver(en => {
      const on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on); setPad(on);
    }, { threshold: 0 }).observe(anchor);
    document.addEventListener('prahla:variant', e => {
      const p = $('[data-sticky-price]', sticky);
      p && (p.textContent = money(e.detail.price));
    });
  }

  /* ---------- copy discount code ---------- */
  document.addEventListener('click', e => {
    const c = e.target.closest('[data-copy]'); if (!c) return;
    navigator.clipboard?.writeText(c.dataset.copy);
    toast((window.PRAHLA?.strings?.copied || 'Code copied') + ': ' + c.dataset.copy);
  });
/* ---------- wishlist — SINGLE SOURCE OF TRUTH ---------- */

const WISHLIST_KEY = 'prahla_wishlist';

/*
  Storage format:

  [
    {
      id: "PRODUCT_ID",
      handle: "product-handle"
    }
  ]
*/

function getWishlist() {
  try {
    const raw = localStorage.getItem(WISHLIST_KEY);

    if (!raw) return [];

    const items = JSON.parse(raw);

    return Array.isArray(items) ? items : [];
  } catch (error) {
    return [];
  }
}


function saveWishlist(items) {
  try {
    localStorage.setItem(
      WISHLIST_KEY,
      JSON.stringify(items)
    );

    /*
      Notify Header + Wishlist Page + other sections
    */
    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          items: items
        }
      })
    );

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          items: items
        }
      })
    );

  } catch (error) {
    console.warn('Wishlist save failed:', error);
  }
}


function paintWishlist() {

  const wishlist = getWishlist();

  const savedIds = new Set(
    wishlist
      .filter(item => item && item.id != null)
      .map(item => String(item.id))
  );


  /*
    Update product wishlist buttons
  */

  $$('[data-wish]').forEach(button => {

    const id = String(
      button.dataset.wish || ''
    );

    const isSaved = savedIds.has(id);

    button.classList.toggle(
      'is-on',
      isSaved
    );

    button.classList.toggle(
      'is-active',
      isSaved
    );

    button.setAttribute(
      'aria-pressed',
      isSaved ? 'true' : 'false'
    );

  });


  /*
    IMPORTANT:
    Header count is controlled by the Header's
    single-source counter.

    We intentionally DO NOT update
    [data-wish-count] here.

    This prevents multiple scripts from
    fighting over the Header count.
  */

}


/*
  Wishlist button click
*/

document.addEventListener(
  'click',
  e => {

    const button =
      e.target.closest('[data-wish]');

    if (!button) return;

    e.preventDefault();

    const id =
      String(button.dataset.wish || '');

    if (!id) return;


    const handle =
      button.dataset.handle || '';


    const wishlist =
      getWishlist();


    const index =
      wishlist.findIndex(
        item =>
          item &&
          String(item.id) === id
      );


    let added;


    if (index > -1) {

      /*
        REMOVE
      */

      wishlist.splice(index, 1);

      added = false;

    } else {

      /*
        ADD
      */

      wishlist.push({
        id: id,
        handle: handle
      });

      added = true;

    }


    saveWishlist(wishlist);

    paintWishlist();


    /*
      Premium toast
    */

    toast(
      added
        ? (
            window.PRAHLA?.strings?.wishOn ||
            'Saved to wishlist'
          )
        : (
            window.PRAHLA?.strings?.wishOff ||
            'Removed from wishlist'
          )
    );

  }
);


/*
  Same-page updates
*/

window.addEventListener(
  'wishlist:updated',
  paintWishlist
);

document.addEventListener(
  'wishlist:updated',
  paintWishlist
);


/*
  Cross-tab updates
*/

window.addEventListener(
  'storage',
  event => {

    if (
      event.key === WISHLIST_KEY ||
      event.key === null
    ) {

      paintWishlist();

    }

  }
);


/*
  Initial paint
*/

paintWishlist();

  /* ---------- recently viewed ---------- */
  if (window.PRAHLA?.productHandle) {
    const RK = 'prahla:recent';
    let r = []; try { r = JSON.parse(localStorage.getItem(RK)) || []; } catch { }
    r = [window.PRAHLA.productHandle, ...r.filter(h => h !== window.PRAHLA.productHandle)].slice(0, 12);
    localStorage.setItem(RK, JSON.stringify(r));
  }
})();

/* ---------------- Currency picker ---------------- */
(function () {
  var root = document.querySelector('[data-cur]');
  if (!root) return;
  var btn = root.querySelector('[data-cur-toggle]');
  var panel = root.querySelector('[data-cur-panel]');
  var form = root.querySelector('#currency-picker-form');
  var input = root.querySelector('[data-cur-input]');
  var search = root.querySelector('[data-cur-search]');
  var empty = root.querySelector('[data-cur-empty]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-cur-value]'));

  function open() {
    panel.hidden = false;
    root.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    if (search) setTimeout(function () { search.focus(); }, 60);
    var active = root.querySelector('.cur__item.is-active');
    if (active) active.scrollIntoView({ block: 'nearest' });
  }
  function close() {
    panel.hidden = true;
    root.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    panel.hidden ? open() : close();
  });

  var closeBtn = root.querySelector('[data-cur-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target) && !panel.hidden) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus(); }
  });

  items.forEach(function (item) {
    item.addEventListener('click', function () {
      input.value = item.getAttribute('data-cur-value');
      item.classList.add('is-active');
      btn.disabled = true;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });

  if (search) {
    search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var hay = (item.getAttribute('data-cur-label') || '') + ' ' + item.textContent;
        var hit = hay.toLowerCase().indexOf(q) > -1;
        item.parentElement.hidden = !hit;
        if (hit) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }
})();
